<template>
    <Sheet id="normalBooking">
        <el-divider>
              <span style="font-size:1.1rem;padding-right: 10px;">
                國秀樓普通教室場地借用
            </span>
        </el-divider>
        <el-form
                :model="model"
                :rules="rules"
                label-width="150px"
                ref="form"
        >
            <el-form-item label="教室" prop="roomId">
                <el-select
                        @change="onChangeRoom"
                        filterable
                        placeholder="請選擇教室"
                        v-model="model.roomId"
                >
                    <el-option
                            :key="room.id"
                            :label="room.name"
                            :value="room.id"
                            v-for="room in rooms"
                    >
                    </el-option>
                </el-select>
                <el-button
                        @click="onShowInfo"
                        style="margin-left: 5px;"
                        type="info"
                >
                    檢視課表及借用情況
                </el-button>
            </el-form-item>
            <div>
                <el-row>
                    <el-col :lg="8" :md="24" :sm="24" :xl="8" :xs="24">
                        <el-form-item label="日期選擇(多選)" prop="dates">
                            <v-date-picker
                                    :max-date="new Date(dateEnd)"
                                    :min-date="bookingDateBegin"
                                    @input="onDateSelect"
                                    is-inline
                                    mode="multiple"
                                    v-model="model.dates"
                            ></v-date-picker>
                        </el-form-item>

                    </el-col>
                    <el-col :lg="16" :md="14" :sm="24" :xl="16" :xs="24" v-if="formattedDates.length > 0">
                        <div style="margin-bottom: 10px;">
                            節次選擇
                            <el-button
                                    @click="onCancelAll"
                                    icon="el-icon-refresh-right"
                                    size="mini"
                                    type="warning"
                            >
                                重設
                            </el-button>
                        </div>
                        <p>
                        ※週一至週五中午時段(12:10~13:00)為第16節
                        </p>

                        <div style="max-height: 300px; overflow-y: auto; ">
                            <el-form-item
                                    :key="d"
                                    :label="`${d}:`"
                                    :prop="d"
                                    v-for="d in formattedDates"

                            >
                                <period-picker
                                        :comparer="(b, e) => e >= b"
                                        :options="getPeriodsOptsWithTime(d)"
                                        @endChange="v => onEndChange(v, d)"
                                        @beginChange="v => onBeginChange(v, d)"
                                        v-model="model[d]"
                                ></period-picker>
                                <el-button
                                        @click="onCancelDate(d)"
                                        style="margin-left: 2px;"
                                        type="danger"
                                >
                                    取消
                                </el-button>
                            </el-form-item>
                        </div>

                    </el-col>
                </el-row>
                <el-row>
                    <el-col :lg="8" :md="14" :sm="24" :xl="5" :xs="24">
                        <el-form-item
                                label="申請人"
                        >
                            {{isStudent ? `${name}(${userId})` : name}}
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :md="14" :sm="24" :xl="5" :xs="24">
                        <el-form-item
                                label="使用人"
                                prop="realUserId"
                                v-if="isEmployee"
                        >
                            <el-select
                                    :disabled="!model.roomId"
                                    :loading="loading.actions['teacher']"
                                    :remote-method="getTeacherSearchFunc"
                                    @change="onSelectRealUser"
                                    filterable
                                    loading-text="查詢中"
                                    no-data-text="無資料"
                                    no-match-text="查無資料"
                                    placeholder="請選擇使用者"
                                    remote
                                    v-model="model.realUserId"
                            >
                                <el-option :label="name" :value="userId"></el-option>
                                <el-option
                                        :key="t.userId"
                                        :label="`${t.name}(${t.userId})`"
                                        :value="t.userId"
                                        v-for="t in teachers"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                label="使用人"
                                prop="realUserId"
                                v-else
                        >
                            {{isStudent ? `${name}(${userId})` : name}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <div style="margin-top: 2px;margin-bottom:15px;margin-left: 90px;">
                    <strong style="color:red;">※請確認聯絡資訊正確，以免影響借用權益</strong>
                </div>
                <el-row>
                    <el-col :lg="8" :md="14" :sm="24" :xl="5" :xs="24">
                        <el-form-item
                                label="Email"
                                prop="email"
                        >
                            <el-input
                                    :disabled="!model.roomId"
                                    placeholder="請輸入電子郵件"
                                    v-model="model.email"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :md="14" :sm="24" :xl="5" :xs="24">
                        <el-form-item
                                label="聯絡電話"
                                prop="contact"
                        >
                            <el-input
                                    :disabled="!model.roomId"
                                    placeholder="請輸入連絡電話"
                                    v-model="model.contact"></el-input>

                        </el-form-item>

                    </el-col>
                </el-row>
                <div class="reason">
                    <el-form-item
                            label="事由"
                    >
                        <el-radio-group v-model="reasonType">
                            <el-radio-button label="course">上課/考試</el-radio-button>
                            <el-radio-button label="other">其它</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="reason">
                        <el-input
                                placeholder="請輸入事由"
                                style="width: 300px;"
                                type="textarea"
                                v-if="reasonType === 'other'"
                                v-model="model.reason"
                        ></el-input>
                        <el-select
                                :loading="loading.actions['course']"
                                :remote-method="getCourseSearchFunc"
                                clearable
                                filterable
                                loading-text="查詢中"
                                no-data-text="無資料"
                                no-match-text="查無資料"
                                placeholder="請選擇課程(輸入名稱或代碼)"
                                remote
                                v-else
                                v-model="model.reason"
                        >
                            <el-option
                                    :key="c.courseId"
                                    :label="`${c.courseId}-${c.subject}(${c.divisionName})`"
                                    :value="`${c.courseId}-${c.subject}(${c.divisionName})`"
                                    v-for="c in optionCourses"
                            ></el-option>
                        </el-select>
                        <div>
                            <small>
                                ※說明:國秀樓普通教室原則上以上課/考試借用為主，如遇無教室可供上課/考試借用，
                                將聯絡其他事由之借用人協調/撤銷借用事宜。
                            </small>
                        </div>
                    </el-form-item>
                </div>

            </div>
        </el-form>
        <el-button @click="submit">送出</el-button>
        <el-dialog
                :title="queryTitle"
                :visible.sync="show"
                top="5vh"
                width="80%"
        >
            <TimetableQueryOfOneRoom
                    :selected-room-id='model.roomId'
                    @cell-click="onCellClick"
            ></TimetableQueryOfOneRoom>
            <template #footer>
                <el-button @click="show=false">關閉</el-button>
            </template>
        </el-dialog>
        <el-dialog
            :visible.sync="noticeShow"
            width="600px"
        >
            <template #title>
              ※國秀樓教室借用系統注意事項
            </template>
            <template #default>
              <ol>
                <li style="margin-bottom: 15px">
                  申請借用教室表件，需配合課表運作以匯入本校電力系統，方能提供相關電化設備使用，匯入時段分三次下午13:00、 晚上18:00及凌晨01:00。
                </li>
                <li style="margin-bottom: 15px">
                  非上述時間內送件且急需借用教室申請者，請於上班時段內，電洽教務處課務組分機2214、進修部課務組分機7015，以個別處理服務。
                </li>
                <li style="margin-bottom: 15px">
                  如發現有設備故障、損壞時，請立即回報管理單位，以便儘速派員維修。
                </li>
                <li style="margin-bottom: 15px">
                  國秀樓普通教室原則上以上課/考試借用為主，如遇無教室可供上課/考試借用，將聯絡其他事由之借用人協調/撤銷借用事宜。
                </li>
                <li style="margin-bottom: 15px">
                  使用國秀樓普通教室期間，請保持適當音量，避免影響周遭其他課堂並協助維持教室環境整潔，以便他人使用。
                </li>
              </ol>
            </template>
        </el-dialog>
    </Sheet>
</template>

<script>
import {mapActions} from 'vuex';
import PeriodPicker from '../PeriodPicker';
import BookingMixin from '../../bookingMixin';
import TimetableQueryOfOneRoom from './TimetableQueryOfOneRoom';
import moment from 'moment';

export default {
        name: 'NormalBooking',
        components: {
            PeriodPicker,
            TimetableQueryOfOneRoom
        },
        mixins: [BookingMixin],
        data: () => ({
          noticeShow: false
        }),
        computed: {},
        methods: {
            ...mapActions('booking', {
                book: 'submitAction',
            }),

            async submit() {
                const {form} = this.$refs;

                await form.validate(async (valid) => {
                    if (valid) {
                        const periods =
                            Object.keys(this.model)
                                .filter(d => moment(d, 'YYYY-MM-DD').isValid())
                                .reduce((ary, key) => ([...ary, {
                                    date: key,
                                    begin: this.model[key][0],
                                    end: this.model[key][1]
                                }]), [])
                        ;

                        const {success, messages = []} = await this.book({
                            ...this.model,
                            roomId: this.selectedRoom.ncutRoomId,
                            userId: this.userId,
                            notForCourseOrExam: this.reasonType !== 'course',
                            schoolYear: this.schoolYear,
                            semester: this.semester,
                            periods
                        });

                        if (success) {
                            this.$message.success('登記成功，請等候審查!!');
                            this.reset();
                            this.$router.push(
                                {
                                    name: 'bookingRst',
                                    params: {success}
                                })
                        } else {
                            this.$message.warning(messages.join(','));
                        }

                    } else {
                        this.$message({
                            type: 'warning',
                            message: '您還有欄位尚未輸入!!'
                        });
                    }
                });
            },
        },
        watch: {
            async schoolYear(current) {
                const {semester} = this;
                await this.getWeekRanges({
                    schoolYear: current,
                    semester
                });
            }
        },

        async created() {
            const {schoolYear, semester} = this;
            await this.getCourses(this.userId);
            if (this.rooms && this.rooms.length > 0) {
                const {roomId, date, periods} = this.$route.params;
                if (roomId) {
                    this.model.roomId = roomId;
                } else {
                    this.model.roomId = this.rooms[0].id;
                }
                if (date && periods && periods.length > 0 && this.isBookingDate(date)) {
                    this.model.dates = [...this.model.dates, new Date(date)];
                    this.model = {...this.model, [date]: periods};
                }
            }
            this.model.realUserId = this.userId;
            if (schoolYear) {
                await this.getWeekRanges({
                    schoolYear,
                    semester
                });
            }
            const self = this;
            setTimeout(() => {
              self.noticeShow = true;
            }, 300);
        }
    }
</script>

<style>
    #normalBooking .el-input__inner {
        min-width: 200px;
        max-width: 200px;
    }

    #normalBooking .reason .el-input__inner {
        max-width: 300px;
    }
</style>
